import type { JackpotProduct } from '../../../@types';
import { useJackpotWinnerOverlay } from '../../../hooks/components/useJackpotWinnerOverlay';
import JackpotWinnerAnimation from './JackpotWinnerAnimation';

type JackpotWinnerOverlayProps = {
  product: JackpotProduct;
};

const JackpotWinnerOverlay = ({ product }: JackpotWinnerOverlayProps) => {
  const { activeJackpot, clearJackpot } = useJackpotWinnerOverlay(product);

  return activeJackpot ? (
    <JackpotWinnerAnimation winningJackpotPool={activeJackpot} clearJackpot={clearJackpot} />
  ) : null;
};

export default JackpotWinnerOverlay;
